import React from 'react';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { formatDate } from "../Utils";

class ContractAmendmentInfos extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { company, nameMo, operation, adressOp, cpOp, cityOp, lastEch, tauxh, paymentMethod, duration, handleChange, nbAmendments, changePaymentMethod, date } = this.props

    return (
      <div className="contract-amendment-infos">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead className="table-head">
              <TableRow className="head-row">
                <TableCell className="MuiTableCell-head" colSpan={2}>
                  DÉTAILS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>
                  <input
                    type="date"
                    name="date"
                    value={date || ""}
                    onChange={(e) => handleChange(e)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Maître d'ouvrage</TableCell>
                <TableCell>
                  {nameMo}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Client</TableCell>
                <TableCell>
                  {company}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Opération</TableCell>
                <TableCell>
                  {operation}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Adresse</TableCell>
                <TableCell>
                  {adressOp && `${adressOp}, ${cpOp} ${cityOp}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Dernière échéance</TableCell>
                <TableCell>
                  {formatDate(lastEch)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Taux horaire</TableCell>
                <TableCell>
                  <input
                    type="number"
                    name="tauxh"
                    value={tauxh === 0 ? "" : tauxh}
                    onChange={(e) => handleChange(e)}
                    disabled={nbAmendments === 0}
                    min="0"
                  />
                  {tauxh !== 0 && <span style={{ marginLeft: 6 }}>€</span>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Mode de paiement</TableCell>
                <TableCell>
                  {(paymentMethod == 26 || paymentMethod == 34) && (
                    <select
                      value={paymentMethod}
                      onChange={(e) => changePaymentMethod(+e.target.value)}
                    >
                      <option value={26}>26%</option>
                      <option value={34}>34%</option>
                    </select>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Durée (mois)</TableCell>
                <TableCell>
                  <input
                    type="number"
                    name="duration"
                    value={duration === 0 ? "" : duration}
                    onChange={(e) => handleChange(e)}
                    disabled={nbAmendments === 0}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {paymentMethod !== 0 && <p className="delai">Délai de <span>{paymentMethod == 26 ? 60 : 30} jours</span> entre les échéances</p>}
      </div>
    )
  }
}
export default ContractAmendmentInfos;